<template>
  <div>
    <router-link
      :to="{ path: $route.fullPath, query: { art: articleId } }"
      class="pdf-link"
    >
      <v-card class="pdf-article">
        <div v-if="isOpenAccess" class="open-access-article-tag">
          <text-highlight :queries="searchTexts">{{
            $t('article.openAccess')
          }}</text-highlight>
        </div>
        <img src="~@/assets/img/pdf.png" class="pdf-image" />

        <p
          class="pdf-title"
          :class="
            searchTexts && searchTexts.length
              ? 'pdf-title-result'
              : 'pdf-title-category'
          "
        >
          <text-highlight :queries="searchTexts">{{
            articleTitle
          }}</text-highlight>
        </p>
      </v-card>
    </router-link>
    <v-dialog
      persistent
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      content-class="pdf-dialog-container"
      @keydown.esc="closeDialog"
    >
      <div>
        <v-toolbar dark color="primary" class="pdf-toolbar">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ currentTitle }}</v-toolbar-title>
          <div v-if="isOpenAccess" class="open-access-tag">
            {{ $t('article.openAccess') }}
          </div>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip bottom :disabled="!originalId">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  @click="toggleOriginal"
                  v-bind="attrs"
                  v-on="on"
                  v-if="originalId"
                >
                  <v-icon v-if="currentArticle === originalId">
                    mdi-script-text
                  </v-icon>
                  <v-icon v-else>mdi-script-text-outline</v-icon>
                </v-btn>
              </template>
              <span v-if="currentArticle === originalId">
                {{ $t('article.seeTranslated') }}
              </span>
              <span v-else>{{ $t('article.seeOriginal') }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="$vuetify.breakpoint.smAndDown"
              bottom
              content-class="pdf-tooltip"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark @click="downloadFile" v-bind="attrs" v-on="on">
                  <v-icon>mdi-download-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('article.download') }}</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <div class="pdf-content">
          <iframe
            v-if="viewerUrl"
            class="pdf-viewer"
            :src="viewerUrl"
            :title="currentTitle"
          ></iframe>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import TextHighlight from 'vue-text-highlight'
import { getArticleTitle } from '@/consts/articles'

export default {
  props: {
    articleId: String,
    articleTitle: String,
    searchTexts: { type: Array, default: () => [] },
    originalId: String,
    isOpenAccess: Boolean
  },
  data() {
    return {
      dialog: false,
      viewerUrl: '',
      showOriginal: false,
      currentArticle: null,
      currentTitle: '',
      originalTitle: ''
    }
  },
  components: {
    TextHighlight
  },
  created() {
    // this.isAdmin = auth.currentUser.email === 'admin@bd-bibliociencia.com'
    this.currentArticle = this.articleId
    this.currentTitle = this.articleTitle

    //Check if article on URL
    if (this.$route.query.art === this.articleId) {
      this.startPDF()
    }

    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (to.query.art !== this.articleId) {
        this.dialog = false
      }
      if (to.query.art === this.articleId) {
        this.startPDF()
      }
      next()
    })

    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },
  methods: {
    startPDF() {
      /*if (this.$route.query.art != this.articleId) {
        this.$router.push({
          path: this.$router.url,
          query: { ...this.$route.query, art: this.articleId }
        })
      }*/
      this.dialog = true
      if (this.showOriginal) {
        if (!this.originalTitle) {
          this.originalTitle = getArticleTitle(this.originalId)
        }
        this.currentArticle = this.originalId
        this.currentTitle = this.originalTitle
      } else {
        this.currentArticle = this.articleId
        this.currentTitle = this.articleTitle
      }
      this.viewerUrl = '/pdf/piccs' + this.currentArticle + '.pdf'

      if (window.location.hostname !== 'localhost') {
        //Analytics Event
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'articuloVisto',
          idArticulo: this.currentArticle,
          tituloArticulo: this.currentTitle,
          division: localStorage.getItem('bd-biblio-division'),
          gid: localStorage.getItem('bd-biblio-gid')
        })
      }
    },
    toggleOriginal() {
      this.showOriginal = !this.showOriginal
      this.startPDF()
    },
    downloadFile() {
      axios({
        url: '/pdf/piccs' + this.currentArticle + '.pdf',
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute(
          'download',
          'BD-BIBLIO-A' +
            this.currentArticle +
            '_' +
            this.currentTitle.substring(0, 60) +
            '.pdf'
        )
        document.body.appendChild(fileLink)

        fileLink.click()

        if (window.location.hostname !== 'localhost') {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'articuloDescargado',
            idArticulo: this.currentArticle,
            tituloArticulo: this.currentTitle,
            division: localStorage.getItem('bd-biblio-division'),
            gid: localStorage.getItem('bd-biblio-gid')
          })
        }
      })
    },
    closeDialog() {
      this.$router.replace({
        path: this.$router.url,
        query: { ...this.$route.query, art: undefined }
      })
      this.dialog = false
      this.viewerUrl = ''
    }
  }
}
</script>
<style lang="scss">
.pdf-tooltip {
  @media only screen and (max-width: 960px) {
    display: none !important;
  }
}
.pdf-link {
  text-decoration: none;
  &.disabled {
    pointer-events: none;
    cursor: default;
  }
  .v-card.pdf-article {
    height: 100%;
    width: 300px;
    text-align: center;
    margin: 0 5px;
    padding: 20px 10px;

    .open-access-article-tag {
      background: #e3e9f0;
      color: #6b85a3;
      position: absolute;
      right: 8px;
      top: 0;
      border-radius: 0 0 4px 4px !important;
      font-size: 12px;
      padding: 5px;
      font-weight: 500;
    }

    .pdf-image {
      width: 70px;
    }
    .pdf-title {
      margin-bottom: 0;
      font-weight: bold;
      color: #002956;

      &.pdf-title-category {
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &.pdf-title-result {
        .text__highlight {
          background: #adeeff;
        }
      }
    }
  }
}

.pdf-dialog-container {
  overflow-x: hidden;
  background: #e6e6e6;

  .pdf-toolbar.v-sheet.v-toolbar {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;

    .open-access-tag {
      background: white;
      text-align: center;
      color: #3d3d3d;
      padding: 5px;
      border-radius: 17px;
      font-size: 14px;
      min-width: 94px;
      min-height: 31px;
      margin-left: 5px;
      font-weight: 500;
    }
  }
  .pdf-content {
    height: calc(100vh - 64px);
    width: 100%;
    overflow: hidden;

    .pdf-viewer {
      border: 0;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
